var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C4.1 0 0.5 3.6 0.5 8C0.5 12.4 4.1 16 8.5 16C12.9 16 16.5 12.4 16.5 8C16.5 3.6 12.9 0 8.5 0ZM9.5 11.5C9.5 11.776 9.276 12 9 12H8C7.724 12 7.5 11.776 7.5 11.5V7.5C7.5 7.224 7.724 7 8 7H9C9.276 7 9.5 7.224 9.5 7.5V11.5ZM8.5 6C7.948 6 7.5 5.552 7.5 5C7.5 4.448 7.948 4 8.5 4C9.052 4 9.5 4.448 9.5 5C9.5 5.552 9.052 6 8.5 6Z",
    fill: "#3DA64F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenExclamation);
export default __webpack_public_path__ + "static/media/green_exclamation.56edf42a3e7dea3d7fda33cd7d22b1f5.svg";
export { ForwardRef as ReactComponent };